export default "__VITE_ASSET__D24Lc$kr__"